// src/data.js
export default [
  {
    imageUrl: require('./assets/Interior/Jodat/1-2-min.jpg'),
    caption: 'طراحی داخلی ساختمان جودت',
    secondaryCaption: 'Interior design of jodat building',
    vid:true,
    secondaryImages: [
      {
        imageUrl: require('./assets/Interior/Jodat/2-min.jpg'),
        description: 'طراحی داخلی ساختمان جودت'
      },
      {
        vidUrl: require('./assets/Interior/Jodat/1-3.mp4'),
        description: null
      },
      {
        imageUrl: require('./assets/Interior/Jodat/3-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Interior/Jodat/4-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Interior/Jodat/5-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Interior/Jodat/6-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Interior/Jodat/7-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Interior/Jodat/8-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Interior/Jodat/9-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Interior/Jodat/10-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Interior/Jodat/11-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Interior/Jodat/12-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Interior/Jodat/13-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Interior/Jodat/14-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Interior/Jodat/15-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Interior/Jodat/16-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Interior/Jodat/17-min.jpg'),
        description: null
      },
    ]
  },
  {
    video: require('./assets/Interior/Jodat/1-3.mp4'),
    caption: 'طراحی داخلی ساختمان جودت',
    secondaryCaption: 'Azarpark store',
    secondaryImages: [
    ]
  },
  {
    imageUrl: require('./assets/Interior/Pastor/1-2-min.jpg'),
    caption: 'طراحی داخلی ساختمان پاستور',
    secondaryCaption: 'Interior design of pastor building',
    secondaryImages: [
      {
        imageUrl: require('./assets/Interior/Pastor/2-min.jpg'),
        description: 'طراحی داخلی ساختمان پاستور'
      },
      {
        imageUrl: require('./assets/Interior/Pastor/3-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Interior/Pastor/4-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Interior/Pastor/5-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Interior/Pastor/6-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Interior/Pastor/7-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Interior/Pastor/8-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Interior/Pastor/9-min.jpg'),
        description: null
      },
    ]
  },
  {
    imageUrl: require('./assets/Interior/Talar/1-2-min.jpg'),
    caption: 'تالار تشریفات شهرداری مرکز تبریز',
    secondaryCaption: 'Ceremonial hall of tabriz municipality',
    vid:true,
    secondaryImages: [
      {
        imageUrl: require('./assets/Interior/Talar/2-min.jpg'),
        description: 'تالار تشریفات شهرداری مرکز تبریز'
      },
      {
        vidUrl: require('./assets/Interior/Talar/1-3.mp4'),
        description: null
      },
      {
        imageUrl: require('./assets/Interior/Talar/3-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Interior/Talar/4-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Interior/Talar/5-min.jpg'),
        description: null
      },
    ]
  },
  {
    imageUrl: require('./assets/Interior/caffe/1-2-min.jpg'),
    caption: 'رستوران هتل بوتیک خیابان فردوسی تبریز',
    secondaryCaption: 'Boutique hotel restaurant',
    vid:true,
    secondaryImages: [
      {
        imageUrl: require('./assets/Interior/caffe/2-min.jpg'),
        description: 'رستوران هتل بوتیک خیابان فردوسی تبریز'
      },
      {
        vidUrl: require('./assets/Interior/caffe/1-3.mp4'),
        description: null
      },
      {
        imageUrl: require('./assets/Interior/caffe/3-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Interior/caffe/4-min.jpg'),
        description: null
      },
    ]
  },
  {
    imageUrl: require('./assets/Interior/AzarPark/1-min.jpg'),
    caption: 'فروشگاه آذرپارک',
    secondaryCaption: 'Azarpark store',
    secondaryImages: [
      {
        imageUrl: require('./assets/Interior/AzarPark/2-min.jpg'),
        description: 'فروشگاه آذرپارک'
      },
      {
        imageUrl: require('./assets/Interior/AzarPark/3-min.jpg'),
        description: null
      },
      {
        imageUrl: require('./assets/Interior/AzarPark/4-min.jpg'),
        description: null
      },
    ]
  },
  
    
    // Add more data as needed
  ];